import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import React, { useCallback, useRef, useState } from 'react';
import chevronDownSmallTokens from '@amzn/meridian-tokens/base/icon/chevron-down-small';
import Menu, { MenuItem } from '@amzn/meridian/menu';
import type { AssociateProfilePlacement } from 'src/services/associateProfile/types';
import { useAppSelector } from 'src/store/store';
import JmrService from 'src/services/jmr/jmrService';
import { createFileUrl, downloadFile } from 'src/utils/fileUtils';
import TwpaModal from 'src/components/pages/placementDetails/twpaModal/twpaModal';
import useModalState from 'src/hooks/useModalState';

interface ActionsProps {
  placement: AssociateProfilePlacement;
}

const ExportActionMenu = ({ placement }: ActionsProps) => {
  const exportLinkRef = useRef<HTMLButtonElement>();
  const [exportMenuOpen, setExportMenuOpen] = useState(false);
  const onClickButton = () => setExportMenuOpen(true);
  const onClose = () => setExportMenuOpen(false);
  const { selectedSite } = useAppSelector((state) => state.sites);
  const { isOpen: isTwpaModalOpen, open: openTwpaModal, close: closeTwpaModal } = useModalState(false);

  const downloadJmr = useCallback(async () => {
    const { data } = await JmrService.downloadJMR(placement.newestJmrFileName);
    if (data) {
      downloadFile(createFileUrl(data, 'application/pdf'), 'jmr-report.pdf');
    }
  }, [placement.newestJmrFileName]);

  return (
    <>
      <Button type="link" ref={exportLinkRef} onClick={onClickButton}>
        Export <Icon tokens={chevronDownSmallTokens} />
      </Button>
      <Menu
        anchorNode={exportLinkRef.current}
        id="update-menu"
        open={exportMenuOpen}
        position="bottom"
        onClose={onClose}
        minWidth="200px"
      >
        <MenuItem onClick={downloadJmr}>Export JMR</MenuItem>
        <MenuItem onClick={openTwpaModal}>Export TWPA</MenuItem>
      </Menu>
      <TwpaModal
        placementId={placement.accommodationId}
        isTwpaModalOpen={isTwpaModalOpen}
        closeTwpaModal={closeTwpaModal}
        allocatedJobShifts={placement.allocatedJobShifts}
        isJobModificationsEnabledForSite={selectedSite.jobModificationsEnabled ?? false}
      />
    </>
  );
};

export default ExportActionMenu;
